"use client";

import { POST_BY_SLUG_QUERYResult } from "@/sanity/types";
import dayjs from "dayjs";
import { useTheme } from "@/contexts/ThemeContext";

type PublishedAtProps = {
  publishedAt: NonNullable<POST_BY_SLUG_QUERYResult>["publishedAt"];
};

export function PublishedAt({ publishedAt }: PublishedAtProps) {
  const { themeColors } = useTheme();

  return publishedAt ? (
    <p
      className={`text-xsmall ${themeColors.headerDateColor}`}
      suppressHydrationWarning
    >
      {dayjs(publishedAt).format("D MMMM YYYY")}
    </p>
  ) : null;
}
